import { render, staticRenderFns } from "./SlScreen.vue?vue&type=template&id=3696aee4&"
import script from "./SlScreen.vue?vue&type=script&lang=js&"
export * from "./SlScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports